import React from 'react'
//TODO FOXIT 替换头部组件
import { NewHeader } from '../components/index'
// import {HeaderContainer} from '../components/index'
import {isMobile} from 'Utils/device';


const HeaderLayout = (props)=>{
    const {pathname} = props.location;
    if (isMobile) {
      switch (pathname) {
        case '/feedback': {
          document.querySelector('html').classList.add('fv__ui-mobile');
          break;
          //return <HeaderContainer/>;
        }
        default:
          break;
      }
      return null;
    }
    switch (pathname) {
        case '/deploying':
        case '/login/success':
        case '/logout/success':
        case '/site/password-expired':
        case '/site/password-change-success':{
            return null;

        }
        default:
            return <NewHeader {...props}/>;
    }
}

// import React,{useEffect} from 'react'
// // import {HeaderContainer} from '../components/index'
// import {isMobile} from 'Utils/device';
// import "./Holder.scss";

// class HeaderHolder extends React.Component{
//     render(){
//         return  <div className='headerHolder header_container'>
//             <div className='leftHolder'></div>
//             <div className='middleHolder'></div>
//             <div className='rightHolder'></div>
//         </div>
//     }
// }
// let RealHeader;


// const HeaderLayout = (props)=>{

//     const [HeaderType, setHeader] = React.useState('holder');

//     useEffect(() => {
//         import('../components/header/HeaderContainer').then(module => {
//             RealHeader = module.default;
//             setHeader('real');
//         });
//     }, []); // 空数组作为依赖项，确保只在组件挂载和卸载时执行一次


//     const {pathname} = props.location;
//     if (isMobile) {
//       switch (pathname) {
//         case '/feedback': {
//           document.querySelector('html').classList.add('fv__ui-mobile');
//           break;
//           //return <HeaderContainer/>;
//         }
//         default:
//           break;
//       }
//       return null;
//     }
//     switch (pathname) {
//         case '/deploying':
//         case '/login/success':
//         case '/logout/success':
//         case '/site/password-expired':
//         case '/site/password-change-success':{
//             return null;

//         }
//         default:
//             return HeaderType==='holder'?<HeaderHolder {...props}></HeaderHolder>:<RealHeader {...props}/>;
//     }
// }

export default HeaderLayout;